export interface PossibleNowRequest {
  ContactElement: { email: string };
  customerdate: string;
  FilterID: string;
  PreferenceAttributes: PreferenceAttributes;
  PreferenceType: number;
}

export type PreferenceAttributes = { Key: string; Value: string }[];
